import React from 'react';
import { gql } from '@apollo/client';
import {
  BooleanInput,
  Datagrid,
  FunctionField,
  NumberField,
  SelectInput,
  TextField,
} from 'react-admin';
import DateTimeField from 'components/DateTimeField';
import DateFilter from 'components/Filter/DateFilter';
import { IdFilter, SearchFilter } from 'components/Filter';
import List from 'components/List';
import LinkField from 'components/LinkField';
import IdField from 'components/IdField';
import { ENUMS } from 'components/Enum/enums';

const ReverseInvoiceFilesFilters = [
  <SearchFilter />,
  <DateFilter alwaysOn label="Date" source="search.created_at" />,
  <SelectInput
    alwaysOn
    label="Status"
    source="search.status"
    emptyText="All"
    choices={Object.values(ENUMS.ReverseInvoiceFile.status).map((status) => ({
      id: status,
      name: status,
    }))}
  />,
  <IdFilter label="Company ID" source="search.company_id" />,
  <IdFilter label="Imported By Account ID" source="search.manually_imported_by_account_id" />,
  <BooleanInput
    alwaysOn
    source="search.is_manually_imported_by_account_id"
    label="Is manually imported?"
  />,
];

const renderAttachment = (record) => {
  const attachmentUrl = record?.attachment;

  if (!attachmentUrl) {
    return '-';
  }

  return (
    <a href={attachmentUrl} target="_blank" rel="noreferrer">
      Download
    </a>
  );
};

const renderErrorShiftsIcon = (record) => {
  if (record?.status === 'pending') {
    return '-';
  }

  if (record?.error_shifts && Array.isArray(record.error_shifts) && record.error_shifts.length) {
    console.log(record.error_shifts, record.error_shifts.length);
    return 'yes';
  }

  return 'no';
};

const ReverseInvoiceFilesList = () => (
  <List
    exporter={false}
    filters={ReverseInvoiceFilesFilters}
    createButtonLabel="Upload Reverse Invoice"
  >
    <Datagrid bulkActionButtons={false} rowClick="show">
      <IdField />
      <LinkField label="Company ID" source="company_id" typename="Company" />
      <TextField label="Status" source="status" />
      <FunctionField label="Has Error?" render={renderErrorShiftsIcon} />
      <TextField label="Original File Name" source="original_file_name" />
      <FunctionField label="Attachment" render={renderAttachment} />
      <LinkField label="Imported By" source="manually_imported_by_account_id" typename="Account" />
      <NumberField label="Total Rows" source="total_rows" />
      <TextField label="Parser" source="parser" />
      <DateTimeField label="Created At" source="created_at" format="MM/dd/yyyy HH:mm" />
      <DateTimeField label="Updated At" source="updated_at" format="MM/dd/yyyy HH:mm" />
    </Datagrid>
  </List>
);

ReverseInvoiceFilesList.query = gql`
  query GET_LIST($input: ReverseInvoiceFileQueryInput) {
    reverseInvoiceFiles(input: $input) {
      id
      attachment
      company_id
      created_at
      manually_imported_by_account_id
      original_file_name
      parser
      status
      total_rows
      updated_at
      error_shifts
    }
    _reverseInvoiceFilesMeta(input: $input) {
      count
    }
  }
`;

export default ReverseInvoiceFilesList;
